// extracted by mini-css-extract-plugin
module.exports = {"divcontainer":"UserInfo_divcontainer__31oL7","divinfo":"UserInfo_divinfo__1nDeV"};